import React from 'react';

import { connect } from 'react-redux';

import { _ } from '../../functions/translator.js';

class InfoCard extends React.Component {
    render() {
        let date;
        let week;
        let render = false 
        if (this.props.day !== 'unset') {
            render = true
            console.log("this.props.day.last",this.props.day.last)
            date = this.props.projectData.days[this.props.day.last].attributes.day
            week = Math.floor(this.props.day/7)
        }
        return(
            <div>
                { render? (
                    <div>
                    <p className="text"> { _('Semana') + ' ' + week + ' - ' + _('Día') + ' ' + this.props.day }</p>
                    <p className="text timeslider-element">{date}</p>
                    </div>
                ):(
                    <div></div>
                )}
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        day         : state.day,
        projectData : state.projectData,
    }
}

export default connect(mapStateToProps)(InfoCard);
